import React from 'react'
import {observer} from 'mobx-react'
import {Col, Collapse as AntCollapse, Row, Typography} from 'antd'
import {Button, BackButton, Collapse, CookiesLinks, Description, Switch} from '@/components'
import {essentialDataSource, statisticsDataSource} from '../../constants/constants'
import { useTranslation } from 'react-i18next'
import {IndividualCookieProps} from './props'
import styles from './styles.scss'
import {
    ACCEPT_ALL_PREFERENCES,
    EXPAND_ESSENTIALS,
    EXPAND_STATISTICS,
    SAVE_COOKIES,
    SWITCH_STATISTICS
} from '@/constants/playwright-ids'

const {Panel} = AntCollapse

export const IndividualCookie: React.FC<IndividualCookieProps> = observer(
    ({onBackClick, onAcceptAllClick, onSaveClick, setStatisticsChecked, statisticsChecked}) => {
        const { t } = useTranslation()
        return (
            <Row gutter={40} justify={'space-between'}>
                <Col span={24}>
                    <Typography.Title level={3}>{t('IndividualCookie.cookies')}</Typography.Title>
                    <Typography.Text>{t('IndividualCookie.cookiesContent')}</Typography.Text>
                    <br />
                    <br />
                    <Button
                        data-test-id={ACCEPT_ALL_PREFERENCES}
                        onClick={onAcceptAllClick}
                        type={'primary'}
                    >
                        {t('IndividualCookie.acceptAll')}
                    </Button>
                    <br />
                    <br />
                    <Button onClick={onSaveClick} data-test-id={SAVE_COOKIES}>
                        {t('IndividualCookie.save')}
                    </Button>
                    <br />
                    <br />
                    <BackButton onClick={onBackClick}>{t('IndividualCookie.back')}</BackButton>
                    <br />
                    <br />
                    <Typography.Title level={4}>{t('IndividualCookie.essential')}</Typography.Title>
                    <Typography.Text>{t('IndividualCookie.essentialContent')}</Typography.Text>
                    <Collapse className={styles.collapse}>
                        <Panel
                            header={t('IndividualCookie.cookieInformation')}
                            key='1'
                            data-test-id={EXPAND_ESSENTIALS}
                        >
                            <Description dataSource={essentialDataSource()} />
                        </Panel>
                    </Collapse>
                    <br />
                    <br />
                    <Typography.Title level={4}>{t('IndividualCookie.statistics')}</Typography.Title>
                    <Typography.Text>{t('IndividualCookie.statisticsContent')}</Typography.Text>
                    <Collapse className={styles.collapse}>
                        <Panel
                            extra={
                                <Switch
                                    checked={statisticsChecked}
                                    onClick={(checked, e) => {
                                        e.stopPropagation()
                                        setStatisticsChecked(checked)
                                    }}
                                    data-test-id={SWITCH_STATISTICS}
                                />
                            }
                            header={t('IndividualCookie.cookieInformation')}
                            key='1'
                            data-test-id={EXPAND_STATISTICS}
                        >
                            <Description dataSource={statisticsDataSource()} />
                        </Panel>
                    </Collapse>
                    <br />
                    <CookiesLinks className={styles.links} />
                </Col>
            </Row>
        )
    }
)
